// TODO(CU-869er847q): folder lives under Forms/ while the component is named Form* —
// settles once components/form, Forms and FormFields are untangled.
import FormSaveButton from "components/Forms/SaveButton";
import Box, { BoxProps } from "ds/components/Box";
import Button from "ds/components/Button";

type FormFooterEditProps = {
  onSubmit: () => void;
  onCancel: () => void;
  isDirty: boolean;
  submitLoading: boolean;
  margin?: BoxProps["margin"];
};

const FormFooterEdit = ({
  onSubmit,
  onCancel,
  isDirty,
  submitLoading,
  margin,
}: FormFooterEditProps) => {
  return (
    <Box justify="end" gap="large" margin={margin}>
      {isDirty && (
        <Button variant="secondary" onPress={onCancel} disabled={submitLoading}>
          Cancel
        </Button>
      )}

      <FormSaveButton onPress={onSubmit} isDirty={isDirty} loading={submitLoading} />
    </Box>
  );
};

export default FormFooterEdit;
